<app-simple-responsive-frame>
    <div class="bg-white">
        <div class="custom-grid-card-center" [formGroup]="nicknameForm">
            <h2 class="section-title">Ponle un nombre a tu {{ propertySelected?.toLowerCase() }}</h2>

            <p class="description">
                El nombre de tu propiedad no se mostrará al público. Es para que tengas un control de tus propiedades en la plataforma.
            </p>

            <input
                type="text"
                class="property-name-input"
                placeholder="Ej: casa abuelos, departamento de dos habitaciones..."
                formControlName="name"
            />

            <div class="error-message" *ngIf="isNotDataValid || nameControl?.dirty">
                <ul class="text-danger list-unstyled">
                    <li *ngFor="let error of getValidationMessages('name')">
                        <p-message severity="error" [text]="error"></p-message>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="15"
        [type]="'complete'"
        [previousPageURL]="'/segments'"
        [nextPageURL]="nextUrl"
        [flowMode]="mode"
        [stepKey]="'nickname'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
    ></app-page-navigation-bar>
</app-simple-responsive-frame>
<p-toast></p-toast>
